import script from "./BroadcastServiceTimesEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./BroadcastServiceTimesEditor.vue?vue&type=script&setup=true&lang=js"

import "./BroadcastServiceTimesEditor.vue?vue&type=style&index=0&id=3e1a33c9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e1a33c9"]])

export default __exports__